export const campaignDoesNotBelongToCompany = (error) => {
  const unauthorizedStatus = error
    && error.response
    && error.response.status === 403;
  return unauthorizedStatus;
};

export default { campaignDoesNotBelongToCompany };
